import React from "react";
import { useInView } from "react-intersection-observer";
import styles from "./Contentright.module.css";
import colors from "../constants/colors.json";

export default function AboutUs({ title, description }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const updatedDescription = description
    ? description
        .replace(/rgb\(0,\s*0,\s*0\)/g, "white")
        .replace(/text-align:\s*(left|right|start|end)/gi, "text-align: center")
        .replace(/direction:\s*ltr/gi, "direction: rtl")
    : "";

  return (
    <div
      className={styles.aboutSection}
      style={{ backgroundColor: colors.primary }}
      dir="rtl"
    >
      <div
        className={`${styles.contentrighttext} ${styles.aboutText} ${styles.contentWrapper} ${
          inView ? styles.inView : ""
        }`}
        ref={ref}
      >
        <div
          className={styles.aboutHtml}
          dangerouslySetInnerHTML={{
            __html: updatedDescription,
          }}
        />
      </div>
    </div>
  );
}
